import { IDataHandler } from '../IDataHandler';
import { SocialActionDataSet } from '../DataSet/SocialAction';
import { SocialActionEventName, allTrackingEvents } from '../TrackingEvent';

type socialDataKey = keyof SocialActionDataSet;

export const socialActionDataMap: Map<
    allTrackingEvents,
    socialDataKey[]
> = new Map<allTrackingEvents, socialDataKey[]>([
    [
        SocialActionEventName.socialAction,
        ['actionLevel', 'actionText', 'targetUserID', 'socialAction'],
    ],
]);

export class SocialActionDataHandler
    implements IDataHandler<SocialActionDataSet> {
    public data: SocialActionDataSet = {
        ...new SocialActionDataSet(),
    };

    public getEventData(eventName: SocialActionEventName): SocialActionDataSet {
        const data = socialActionDataMap.get(eventName).reduce((acc, key) => {
            acc[key] = this.data[key] as never;
            return acc;
        }, {} as SocialActionDataSet);

        if (eventName === SocialActionEventName.socialAction) {
            this.data = new SocialActionDataSet();
        }
        return data;
    }

    public clearData(): void {
        this.data = {
            ...new SocialActionDataSet(),
        };
    }
}
